import EventsApi from '../api/EventsApi';
import EventsConstants from '../constants/EventsConstants';

function searchEvents(query = {}) {
  return {
    query,
    types: [
      EventsConstants.SEARCH_EVENTS_REQUEST,
      EventsConstants.SEARCH_EVENTS_SUCCESS,
      EventsConstants.SEARCH_EVENTS_FAILURE
    ],
    apiRequest: (state, client) => EventsApi.searchEvents({ ...query, limit: 20 }, client)
  };
}

function getCalloutFeaturedEvent() {
  return {
    types: [
      EventsConstants.FETCH_CALLOUT_FEATURED_EVENT_REQUEST,
      EventsConstants.FETCH_CALLOUT_FEATURED_EVENT_SUCCESS,
      EventsConstants.FETCH_CALLOUT_FEATURED_EVENT_FAILURE
    ],
    apiRequest: (state, client) =>
      EventsApi.getEvents(
        {
          featured: true,
          cancelled: false,
          full: false,
          limit: 1,
          sort: 'definition.start asc'
        },
        client
      )
  };
}

export default {
  searchEvents,
  getCalloutFeaturedEvent
};
